import React, { useMemo } from "react";
import styles from "./index.module.scss";
import { sendMessageToParent } from "../../utils";
import { isMobile } from "react-device-detect";

interface FeatureItem {
  icon: string;
  title: string;
  desc?: {
    title: string;
    content: any;
  };
  id?: string;
  link?: string;
}

const features_m: FeatureItem[] = [
  {
    icon: "https://cdn.shopify.com/s/files/1/0506/5284/0124/files/duty_free-6.9.png?v=1749457707",
    title: "Duty-Free<br />Delivery",
    id: "duty-free-delivery_m",
    link: "/pages/shipping-policies",
    desc: {
      title: "Duty-Free Delivery",
      content: ``,
    },
  },
  {
    icon: "https://cdn.shopify.com/s/files/1/0506/5284/0124/files/lifetime-6.9.png?v=1749457708",
    title: "Lifetime Wardrobe<br />Refresh",
    id: "lifetime-wardrobe-refresh_m",
    link: "/blogs/what-we-do/old-clothes-get-new-opportunities-join-ogls-trade-in-recycling-program-1",
    desc: {
      title: "Lifetime Wardrobe Refresh",
      content: ``,
    },
  },
  {
    icon: "https://cdn.shopify.com/s/files/1/0506/5284/0124/files/vip-6.9.png?v=1749457708",
    title: "Exclusive VIP<br />Service",
    id: "exclusive-vip-service_m",
    link: "mailto: Bonnie@oglmove.com",
    desc: {
      title: "Exclusive VIP Service",
      content: ``,
    },
  },
];

const features_pc: FeatureItem[] = [
  {
    icon: "https://cdn.shopify.com/s/files/1/0506/5284/0124/files/duty_free-6.9.png?v=1749457707",
    title: "Duty-Free<br />Delivery",
    id: "duty-free-delivery__pc",
    link: "/pages/shipping-policies",
    desc: {
      title: "Duty-Free Delivery",
      content: ``,
    },
  },
  {
    icon: "https://cdn.shopify.com/s/files/1/0506/5284/0124/files/lifetime-6.9.png?v=1749457708",
    title: "Lifetime Wardrobe<br />Refresh",
    id: "lifetime-wardrobe-refresh__pc",
    link: "/blogs/what-we-do/old-clothes-get-new-opportunities-join-ogls-trade-in-recycling-program-1",
    desc: {
      title: "Lifetime Wardrobe Refresh",
      content: ``,
    },
  },
  {
    icon: "https://cdn.shopify.com/s/files/1/0506/5284/0124/files/vip-6.9.png?v=1749457708",
    title: "Exclusive VIP<br />Service",
    id: "exclusive-vip-service__pc",
    link: "mailto: Bonnie@oglmove.com",
    desc: {
      title: "Exclusive VIP Service",
      content: ``,
    },
  },
];

const MemberFeatures: React.FC = () => {
  const features = useMemo(() => {
    return isMobile ? features_m : features_pc;
  }, []);

  const handleFeatureClick = (feature: FeatureItem) => {
    sendMessageToParent({ type: "goto", url: feature?.link });
  };

  return (
    <div className={styles.memberFeatures}>
      <div className={styles.featuresGrid}>
        {features.map((feature, index) => (
          <React.Fragment key={index}>
            <div
              className={styles.featureItem}
              data-element-id={feature.id}
              onClick={() => handleFeatureClick(feature)}
            >
              <div className={`${styles.featureIcon}`}>
                <img src={feature.icon} alt={feature.title} />
              </div>
              <div className={styles.featureTitle}>
                <div dangerouslySetInnerHTML={{ __html: feature.title }} />
              </div>
            </div>
            {index !== features.length - 1 && (
              <div className={styles.divider}></div>
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default MemberFeatures;
